import api from "../../services/api";
import {
  GET_USER_LOGS_FAILURE,
  GET_USER_LOGS_REQUEST,
  GET_USER_LOGS_SUCCESS,
  GET_USER_LOGS_BY_USER_ID_REQUEST,
  GET_USER_LOGS_BY_USER_ID_SUCCESS,
  GET_USER_LOGS_BY_USER_ID_FAILURE,
  GET_USER_LOGS_BY_IP_REQUEST,
  GET_USER_LOGS_BY_IP_SUCCESS,
  GET_USER_LOGS_BY_IP_FAILURE,
} from "./ActionType";

const getUserLogsRequest = () => ({
  type: GET_USER_LOGS_REQUEST,
});

const getUserLogsSuccess = (userLogsResponse) => ({
  type: GET_USER_LOGS_SUCCESS,
  payload: userLogsResponse,
});

const getUserLogsFailure = (error) => ({
  type: GET_USER_LOGS_FAILURE,
  payload: error,
});

export const getUserLogs = (page = 0) => async (dispatch) => {
  dispatch(getUserLogsRequest());
  try {
    const response = await api.get(`/activity-logs?page=${page}`);
    dispatch(getUserLogsSuccess(response.data));
  } catch (error) {
    dispatch(getUserLogsFailure(error.response?.data || error.message));
  }
};

const getUserLogsByUserIdRequest = () => ({
  type: GET_USER_LOGS_BY_USER_ID_REQUEST,
});

const getUserLogsByUserIdSuccess = (userLogsResponse) => ({
  type: GET_USER_LOGS_BY_USER_ID_SUCCESS,
  payload: userLogsResponse,
});

const getUserLogsByUserIdFailure = (error) => ({
  type: GET_USER_LOGS_BY_USER_ID_FAILURE,
  payload: error,
});

export const getUserLogsByUserId = (userId, page = 0) => async (dispatch) => {
  dispatch(getUserLogsByUserIdRequest());
  try {
    const response = await api.get(`/activity-logs/user/${userId}?page=${page}`);
    dispatch(getUserLogsByUserIdSuccess(response.data));
  } catch (error) {
    dispatch(getUserLogsByUserIdFailure(error.response?.data || error.message));
  }
};

const getUserLogsByIpRequest = () => ({
  type: GET_USER_LOGS_BY_IP_REQUEST,
});

const getUserLogsByIpSuccess = (userLogsResponse) => ({
  type: GET_USER_LOGS_BY_IP_SUCCESS,
  payload: userLogsResponse,
});

const getUserLogsByIpFailure = (error) => ({
  type: GET_USER_LOGS_BY_IP_FAILURE,
  payload: error,
});

export const getUserLogsByIpAddress = (ipAddress, page = 0) => async (dispatch) => {
  dispatch(getUserLogsByIpRequest());
  try {
    const response = await api.get(`/activity-logs/ip/${ipAddress}?page=${page}`);
    dispatch(getUserLogsByIpSuccess(response.data));
  } catch (error) {
    dispatch(getUserLogsByIpFailure(error.response?.data || error.message));
  }
};

